import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":"","ma-0":"","pa-0":""}},[_c(VContainer,{staticClass:"d-flex flex-column flex-md-row flex-lg-row flex-xl-row",attrs:{"fluid":"","ma-0":"","pa-0":"","xs12":"","md12":""}},[_c(VFlex,{attrs:{"xs12":"","md7":"","lg7":""}},[_c(VContainer,[_c(VCard,{staticClass:"pa-4"},[_c('GeneralForm',{attrs:{"projectType":_vm.tipo}})],1)],1)],1),_c(VFlex,{staticClass:"scribble-background",attrs:{"xs12":"","md5":"","lg5":"","secondary":""}},[_c('Aside')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }